// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.digim-card-station-row {
  align-items: center;
}

.digim-card-station-col {
  padding: 0;
  vertical-align: middle;
}

.digim-card-title-station-text {
  display: block;
  font-size: 16px;
  width: 100%;
  color: var(--color-black-light);
  text-align: center;
  font-family: Calibri;
  margin: 0;
  font-weight: 600;
}

.digim-card-small-station-text {
  display: block;
  font-size: 32px;
  width: 100%;
  color: var(--color-black-light);
  text-align: center;
  font-family: Calibri;
}

.blue-80 {
  border-bottom: 2px solid var(--color-blue-2-light);
  width: 80%;
  margin: auto;
}

/* dark theme styles */
.dark .digim-card-title-station-text {
  color: var(--color-black-dark);
}
.dark .digim-card-small-station-text {
  color: var(--color-black-dark);
}
.dark .blue-80 {
  border-bottom: 2px solid var(--color-blue-2-dark);
}`, "",{"version":3,"sources":["webpack://./src/app/components/widgets/stations-widget/stations-widget.component.scss","webpack://./../../../../../Ryan%20Ticer/source/repos/seacom3/ui/src/app/components/widgets/stations-widget/stations-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;ACCF;;ADEA;EACE,UAAA;EACA,sBAAA;ACCF;;ADEA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;ACCF;;ADEA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,oBAAA;ACCF;;ADEA;EACE,kDAAA;EACA,UAAA;EACA,YAAA;ACCF;;ADEA,sBAAA;AAEE;EACE,8BAAA;ACAJ;ADGE;EACE,8BAAA;ACDJ;ADIE;EACE,iDAAA;ACFJ","sourcesContent":[".digim-card-station-row {\r\n  align-items: center;\r\n}\r\n\r\n.digim-card-station-col {\r\n  padding: 0;\r\n  vertical-align: middle;\r\n}\r\n\r\n.digim-card-title-station-text {\r\n  display: block;\r\n  font-size: 16px;\r\n  width: 100%;\r\n  color: var(--color-black-light);\r\n  text-align: center;\r\n  font-family: Calibri;\r\n  margin: 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.digim-card-small-station-text {\r\n  display: block;\r\n  font-size: 32px;\r\n  width: 100%;\r\n  color: var(--color-black-light);\r\n  text-align: center;\r\n  font-family: Calibri;\r\n}\r\n\r\n.blue-80 {\r\n  border-bottom: 2px solid var(--color-blue-2-light);\r\n  width: 80%;\r\n  margin: auto;\r\n}\r\n\r\n/* dark theme styles */\r\n.dark {\r\n  .digim-card-title-station-text {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .digim-card-small-station-text {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .blue-80 {\r\n    border-bottom: 2px solid var(--color-blue-2-dark);\r\n  }\r\n}\r\n",".digim-card-station-row {\n  align-items: center;\n}\n\n.digim-card-station-col {\n  padding: 0;\n  vertical-align: middle;\n}\n\n.digim-card-title-station-text {\n  display: block;\n  font-size: 16px;\n  width: 100%;\n  color: var(--color-black-light);\n  text-align: center;\n  font-family: Calibri;\n  margin: 0;\n  font-weight: 600;\n}\n\n.digim-card-small-station-text {\n  display: block;\n  font-size: 32px;\n  width: 100%;\n  color: var(--color-black-light);\n  text-align: center;\n  font-family: Calibri;\n}\n\n.blue-80 {\n  border-bottom: 2px solid var(--color-blue-2-light);\n  width: 80%;\n  margin: auto;\n}\n\n/* dark theme styles */\n.dark .digim-card-title-station-text {\n  color: var(--color-black-dark);\n}\n.dark .digim-card-small-station-text {\n  color: var(--color-black-dark);\n}\n.dark .blue-80 {\n  border-bottom: 2px solid var(--color-blue-2-dark);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
